var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.actionType && _vm.activity.tasks[0].company_id
        ? _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("remove", _vm.activity)
                }
              }
            },
            [
              _c(
                "v-avatar",
                {
                  attrs: {
                    size: "25",
                    title: _vm.getCompanyName(_vm.activity.tasks[0].company_id)
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.getCompanyImage(_vm.activity.tasks[0].company_id)
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    { staticClass: "trash", attrs: { size: "20" } },
                    [_vm._v("delete")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.actionType && _vm.activity && _vm.activity.company
        ? _c(
            "v-btn",
            {
              staticClass: "button-hover",
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("remove", _vm.activity, _vm.company)
                }
              }
            },
            [
              _c(
                "v-avatar",
                { attrs: { size: "25", title: _vm.company.name } },
                [
                  _c("img", { attrs: { src: _vm.company.image } }),
                  _vm._v(" "),
                  _c("v-icon", { attrs: { size: "20" } }, [_vm._v("delete")])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11881cf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11881cf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/_Molecules/AssignmentRemoveButton.vue
// module id = null
// module chunks = 